/* eslint-disable camelcase */
/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import LoggedInHeader from './LoggedInHeader';
import LoggedOutHeader from './LoggedOutHeader';
import { isIosAppSignInLoginPage } from '../../util/appSignIn';

const NewHeader = ({ ...props }) => {
  const {
    hasAuthCreds, hasCompletedWalkthrough, showSignUp, cable, location,
  } = props;

  if (hasAuthCreds === null || (hasAuthCreds && !hasCompletedWalkthrough)) return null;

  // In the Medsender iOS app's sign-in sheet (the login or Forgot password on its way to the app's
  // printer sign-in page, also back from a failed Microsoft sign-in that started there): no sign-up
  // and no link to the marketing site, at any width. Gibraltar's login keeps both.
  const iosAppSignIn = isIosAppSignInLoginPage(location?.search);

  return (
    <div className="new-header">
      {hasAuthCreds ? (
        <LoggedInHeader cable={cable} />
      ) : (
        <LoggedOutHeader showSignUp={showSignUp && !iosAppSignIn} linkLogo={!iosAppSignIn} />
      )}
    </div>
  );
};

NewHeader.propTypes = {
  hasAuthCreds: PropTypes.bool,
  hasCompletedWalkthrough: PropTypes.bool.isRequired,
  showSignUp: PropTypes.bool,
  cable: PropTypes.shape({
    subscriptions: PropTypes.shape({
      create: PropTypes.func.isRequired,
    }).isRequired,
  }),
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

NewHeader.defaultProps = {
  hasAuthCreds: false,
  showSignUp: true,
  cable: null,
  location: undefined,
};

export { NewHeader };

export default connect((state) => ({
  hasAuthCreds: state.auth.hasAuthCreds,
  hasCompletedWalkthrough: state.auth.hasCompletedWalkthrough,
}))(withRouter(NewHeader));
